<div class="d-flex justify-content-between">
  <div
    *ngIf="orderDetails?.cardPaymentHistory &&
              orderDetails?.cardPaymentHistory[
                orderDetails.cardPaymentHistory.length - 1
              ]?.isPaid
            "
  >
    {{ 'DETAILS.BENEFIT.CARD_DIFFERENCE' | translate }}
  </div>

  <div
    *ngIf="orderDetails?.cardPaymentHistory &&
              orderDetails?.cardPaymentHistory[
                orderDetails.cardPaymentHistory.length - 1
              ]?.isPaid === false
            "
  >
    {{ 'DETAILS.BENEFIT.AMOUNT_DUE_CARD' | translate }}
  </div>

  <div
    class="semi-bold dark-green text-right"
    *ngIf="orderDetails?.cardPaymentHistory &&
              orderDetails?.cardPaymentHistory[
                orderDetails.cardPaymentHistory.length - 1
              ]
            "
  >
    {{
      orderDetails?.cardPaymentHistory[orderDetails.cardPaymentHistory.length - 1].cardDifference | number: '1.2-2'
    }}
    {{ 'DETAILS.UNIT1' | translate }}
  </div>
</div>
